module.exports = __webpack_public_path__ + "img/network-transparency.8a009a08.png";